<template>
	<button
		type="button"
		class="group z-50 hidden h-[44px] w-[139px] max-w-[139px] items-center justify-center !rounded-[20px] bg-gray-100 px-5 py-2 transition-colors ease-linear hover:bg-primary-2 hover:text-white md:flex lg:flex xl:flex"
	>
		<slot>Go Back</slot>
	</button>
</template>
